const banks = {
  PLACEHOLDER: {
    code: '000',
    ispb: null
  },
  BANCO_DO_BRASIL: {
    code: '001',
    ispb: '00000000'
  },
  ITAU: {
    code: '341',
    ispb: '60701190'
  },
  SANTANDER: {
    code: '033',
    ispb: '90400888'
  },
  CAIXA_ECONOMICA: {
    code: '104',
    ispb: '00360305'
  },
  INTER: {
    code: '077',
    ispb: '00416968'
  },
  AGIPLAN: {
    code: '121',
    ispb: '10664513'
  },
  SICOOB: {
    code: '756',
    ispb: '02038232'
  },
  SICREDI: {
    code: '748',
    ispb: '01181521'
  },
  NU_PAGAMENTO: {
    code: '260',
    ispb: '18236120'
  },
  BRADESCO: {
    code: '237',
    ispb: '60746948'
  },
  BANCO_RENDIMENTO: {
    code: '633',
    ispb: '68900810'
  },
  VOTORANTIM: {
    code: '655',
    ispb: '59588111'
  },
  TOPAZIO: {
    code: '082',
    ispb: '07679404'
  },
  NEON: {
    code: '655',
    ispb: '20855875'
  },
  BANCO_TOPAZIO: {
    code: '082',
    ispb: '07679404'
  },
  ABC_BRASIL: {
    code: '246',
    ispb: '28195667'
  },
  STONE: {
    code: '197',
    ispb: '16501555'
  },
  C6_BANK: {
    code: '336',
    ispb: '61533584'
  },
  BTG: {
    code: '208',
    ispb: '30306294'
  }
};

module.exports = banks;
